import { FC, Fragment, useCallback, useMemo, useState } from 'react';

import { TErrorDetails } from './WarningModal.constants';
import ChevronArrow from './ChevronArrow';
import cn from 'utils/cn';

type TProps = {
  showErrorDetails: boolean;
  errorDetails: TErrorDetails;
};

const MORE_DETAILS_TEXT = {
  show: 'Show',
  hide: 'Hide',
};

const MoreDetails: FC<TProps> = ({ errorDetails, showErrorDetails }) => {
  const [showMore, setShowMore] = useState(true);

  const toggleShowMore = useCallback(() => {
    setShowMore(!showMore);
  }, [showMore]);

  const errorDetailsString = useMemo(() => {
    try {
      return JSON.stringify(errorDetails, null, 4);
    } catch (e) {
      console.warn('Unable to stringify', errorDetails);
    }
  }, [errorDetails]);

  if (!showErrorDetails) return null;

  return (
    <Fragment>
      <button
        className="warning-modal__button tw:cursor-pointer tw:flex tw:items-center tw:bg-transparent tw:!mt-6 tw:text-secondary-500 tw:!text-xs tw:font-light tw:border-none"
        onClick={toggleShowMore}
        type="button"
        data-testid="more-details-btn"
      >
        <ChevronArrow showMore={showMore} />
        <span className="tw:w-[100px]">
          {showMore ? MORE_DETAILS_TEXT.hide : MORE_DETAILS_TEXT.show} Error Details
        </span>
        <ChevronArrow showMore={showMore} />
      </button>

      <pre
        data-testid="more-details-pre"
        className={cn(
          'Roboto tw:break-all tw:text-left tw:text-wrap tw:!text-sm tw:text-primary-600 tw:w-[672px] tw:transition-[height]',
          showMore
            ? 'tw:h-[220px] tw:overflow-auto tw:p-6 tw:border-primary-500 tw:border-2'
            : 'tw:h-0 tw:overflow-hidden tw:p-0 tw:m-0'
        )}
      >
        {errorDetailsString}
      </pre>
    </Fragment>
  );
};

export default MoreDetails;
